export default __webpack_public_path__ + "static/media/arrow-next.29a1a2e1.svg";